import Api from '@/api/api';

export default {
    getSpeedlimit() {
        return Api.get('api/Settings/GetSpeedLimit');
    },
    addSpeedLimit (body) {
        return Api.post('api/Settings/AddSpeedLimit', body);
    },
    updateSpeedLimit (body) {
        return Api.put(`/api/Settings/UpdateSpeedLimit`, body.data);
    },
    removeSpeedLimit(id) {
        return Api.delete(`/api/Settings/DeleteSpeedLimit/${id}`);
    },
    getVehicleSpeedLimitColors() {
        return Api.get('/api/Settings/GetSpeedLimitColor');
    },
    changeSpeedLimitColor (body) {
        return Api.post(`/api/Settings/AddUpdateSpeedLimitColor`, body);
    },
}